import axios from 'axios';
export function subscribeToNewsletter(email, regionId) {
    return axios
        .post(`${process.env.CORE_API}/newsletter/subscribe`, { email, regionId })
        .then(() => true)
        .catch(() => false);
}
